import { render, staticRenderFns } from "./u-txt-items.vue?vue&type=template&id=1c92da89&scoped=true&"
import script from "./u-txt-items.vue?vue&type=script&lang=js&"
export * from "./u-txt-items.vue?vue&type=script&lang=js&"
import style0 from "./u-txt-items.vue?vue&type=style&index=0&id=1c92da89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c92da89",
  null
  
)

export default component.exports